import { EMPTY_VALUE } from '../constants/styles';
import { formatPercent } from './string';

/**
 * Показывает долю части от целого процентом: 400 из 4000 — «10.0%». Целое, равное нулю или
 * неизвестное, доли не задаёт — она показывается прочерком: решение, чем заменить
 * отсутствующее значение, принадлежит форматтеру, иначе каждое место показа выбирало бы
 * замену само и они бы разошлись.
 */
export const formatShare = (part: number | null | undefined, total: number | null | undefined): string =>
  part == null || total == null || total === 0 ? EMPTY_VALUE : formatPercent((part / total) * 100);
